import { SearchIcon } from "app/components/Icons";
import Input from "app/components/Input";
import clsx from "clsx";
import React from "react";

interface Props {
  isMultiSelect: boolean;
  headingText?: string;
  searchPlaceholder?: string;
  isAllSelected?: boolean;
  handleSelectAll?: () => void;
  search: string;
  setSearch: (val: string) => void;
  hideSearchIcon: boolean;
  headerAreaClassName?: string;
  headingTextClassName?: string;
  inputNoBorder?: boolean;
  showSearch?: boolean;
  isExternalSearch?: boolean;
  externalOnSearchChange?: (search: string) => void;
  externalSearchValue?: string;
}
const MenuHeader: React.FC<Props> = ({
  isMultiSelect,
  search,
  setSearch,
  handleSelectAll,
  headingText,
  isAllSelected,
  searchPlaceholder,
  hideSearchIcon,
  headerAreaClassName,
  inputNoBorder,
  headingTextClassName,
  showSearch = true,
  isExternalSearch,
  externalOnSearchChange,
  externalSearchValue,
}) => {
  return isMultiSelect ? (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between px-4 py-3 text-secondary tracking-[0.56px] text-sm font-semibold leading-[21px] uppercase border-b border-[#E9ECF2]">
        <span>{headingText ?? "members"}</span>
        <div className="flex items-center gap-2">
          <button
            className="text-blue-600 text-md font-medium focus:outline-none text-[#5A8DF1] "
            onClick={handleSelectAll}
          >
            {isAllSelected ? "Unselect All" : "Select All"}
          </button>
        </div>
      </div>
      {showSearch && (
        <Input
          containerClassName="px-2 pb-1"
          id="search"
          placeholder={searchPlaceholder ?? "Search by assignee or role "}
          value={isExternalSearch ? externalSearchValue : search}
          onKeyDown={(e) => {
            if (isExternalSearch) {
              // Prevent DropdownMenu typeahead from moving focus to list items.
              e.stopPropagation();
            }
          }}
          onChange={(e) => {
            e.stopPropagation();
            if (isExternalSearch) {
              externalOnSearchChange?.(e.target.value);
            } else {
              setSearch(e.target.value);
            }
          }}
        />
      )}
    </div>
  ) : (
    <div className={clsx("flex flex-col gap-2 ", headerAreaClassName)}>
      {showSearch && (
        <Input
          noBorder={!inputNoBorder}
          id="search"
          icon={
            hideSearchIcon ? null : <SearchIcon size="17" color="#79808A" />
          }
          placeholder={searchPlaceholder ?? "Search by assignee or role "}
          value={search}
          onChange={(e) => {
            e.stopPropagation();
            setSearch(e.target.value);
          }}
          innerContainerClassName="px-2 pb-1 border-b-[1px] border-gray-100 "
        />
      )}

      {headingText && (
        <div
          className={clsx(
            "flex items-center justify-between px-4 py-3 text-secondary tracking-[0.56px] text-sm font-semibold leading-[21px] uppercase ",
            headingTextClassName,
          )}
        >
          <span>{headingText}</span>
        </div>
      )}
    </div>
  );
};

export default MenuHeader;
